import { Row, Col } from 'antd';
import DiagnosticReportUtils from '../../../misc/DiagnosticReportUtils';

export function IntroSumSHS(props) {
   return (
      <div>
         <p style={{ marginTop: '0pt', marginBottom: '0pt' }}>
            <strong>&nbsp;</strong>
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '0pt',
               textAlign: 'center',
               lineHeight: '115%',
               fontSize: '14pt',
            }}
         >
            <a name="_Hlk99823754">
               <strong>
                  SUMMARY RESULTS{' '}
                  {props.diagnostic_type === 'pre' ? 'PRE' : 'POST'} TEST
               </strong>
            </a>
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '0pt',
               textAlign: 'center',
            }}
         >
            <strong>&nbsp;</strong>
         </p>
         <table
            style={{
               width: '100%',
               border: '0.75pt solid #cccccc',
               borderCollapse: 'collapse',
            }}
         >
            <tbody>
               <tr>
                  <td
                     style={{
                        width: '15.24%',
                        borderStyle: 'solid',
                        borderWidth: '0.75pt',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           fontSize: '12pt',
                        }}
                     >
                        <strong>Test Taken: </strong>
                     </p>
                  </td>
                  <td
                     colSpan={2}
                     style={{
                        borderStyle: 'solid',
                        borderWidth: '0.75pt',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           fontSize: '12pt',
                        }}
                     >
                        {props.subject}
                     </p>
                  </td>
               </tr>
               <tr>
                  <td
                     style={{
                        width: '15.24%',
                        borderStyle: 'solid',
                        borderWidth: '0.75pt',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           fontSize: '12pt',
                        }}
                     >
                        <strong>Grade Level:</strong>
                     </p>
                  </td>
                  <td
                     colSpan={2}
                     style={{
                        borderStyle: 'solid',
                        borderWidth: '0.75pt',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           fontSize: '12pt',
                        }}
                     >
                        {props.grade_level}
                     </p>
                  </td>
               </tr>
               <tr>
                  <td
                     style={{
                        width: '15.24%',
                        borderStyle: 'solid',
                        borderWidth: '0.75pt',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           fontSize: '12pt',
                        }}
                     >
                        <strong>Section:</strong>
                     </p>
                  </td>
                  <td
                     colSpan={2}
                     style={{
                        borderStyle: 'solid',
                        borderWidth: '0.75pt',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           fontSize: '12pt',
                        }}
                     >
                        {props.section}
                     </p>
                  </td>
               </tr>
               <tr>
                  <td
                     style={{
                        width: '15.24%',
                        borderStyle: 'solid',
                        borderWidth: '0.75pt',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           fontSize: '12pt',
                        }}
                     >
                        <strong>School: </strong>
                     </p>
                  </td>
                  <td
                     colSpan={2}
                     style={{
                        borderStyle: 'solid',
                        borderWidth: '0.75pt',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           fontSize: '12pt',
                        }}
                     >
                        {props.school_name}
                     </p>
                  </td>
               </tr>
               <tr>
                  <td
                     style={{
                        width: '15.24%',
                        borderStyle: 'solid',
                        borderWidth: '0.75pt',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           fontSize: '12pt',
                        }}
                     >
                        <strong>Date:</strong>
                     </p>
                  </td>
                  <td
                     colSpan={2}
                     style={{
                        borderStyle: 'solid',
                        borderWidth: '0.75pt',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           fontSize: '12pt',
                        }}
                     >
                        {props.diagnostic_date}
                     </p>
                  </td>
               </tr>
            </tbody>
         </table>

         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '100%',
               fontSize: '12pt',
            }}
         >
            <strong>&nbsp;</strong>
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '100%',
               fontSize: '12pt',
            }}
         >
            <strong>Purpose of the Assessment:</strong>
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
               textAlign: 'justify',
            }}
         >
            The SHS Specialized Subject Learning Assessment Package determines
            how much the learners have benefited from the instruction on SHS
            Specialized Subject. A test is taken by the student for the SHS
            Specialized Subject that determines a set of standard competencies
            based on the National Curriculum. These learning competencies are
            classified according to the content standards as presented in the
            results. When the learning competency is already taken up in class,
            the purpose of the assessment is to determine the learners’
            achievement or what they have learned from instruction. If the
            learning competency tested is not yet taken, the results serve as
            diagnostic or determine what students’ know and does not know so
            that necessary adjustment in the teaching and learning process can
            be prepared.&nbsp; The assessment is used by the teaching staff and
            school administrators to provide the necessary instructional
            programs to address the learning of the students.
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '0pt',
               lineHeight: '100%',
               fontSize: '12pt',
            }}
         >
            <strong>&nbsp;</strong>
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '100%',
               fontSize: '12pt',
            }}
         >
            <strong>Areas Measured by the Assessment:</strong>
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
               textAlign: 'justify',
            }}
         >
            The assessment measures the learning competencies and content
            standards for {props.subject}. The following are the corresponding
            content standards. The detailed results for learning competencies
            and content standards are found in the succeeding pages of the
            summary report.
         </p>

         <ul style={{ margin: '0pt', paddingLeft: '0pt' }}>
            {props.content_standards
               .filter(({ label }) => label !== 'TOTAL')
               .map(({ label }) => (
                  <li
                     className="ListParagraph"
                     style={{
                        marginLeft: '10.06pt',
                        paddingLeft: '7.94pt',
                        fontFamily: 'serif',
                     }}
                  >
                     <span style={{ fontFamily: 'Calibri' }}>{label}</span>
                  </li>
               ))}
         </ul>

         <p
            style={{
               marginTop: '10pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
               textAlign: 'justify',
            }}
         >
            The results of the SHS Specialized Subject learning assessment
            package are provided for the students and school personnel.
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
               textAlign: 'justify',
            }}
         >
            For the student’s report, the results are shown for each learning
            competency and the content standards. The details about the
            interpretation are found in the succeeding section.
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
               textAlign: 'justify',
            }}
         >
            The report for the school personnel is composed of three levels: (1)
            Results for all levels, (2) Results for each level, and (3) Results
            for each section. These three levels of report contain the
            following:
         </p>
         <ul style={{ margin: '0pt', paddingLeft: '0pt' }}>
            <li
               className="ListParagraph"
               style={{
                  marginLeft: '10.06pt',
                  paddingLeft: '7.94pt',
                  fontFamily: 'serif',
               }}
            >
               <span style={{ fontFamily: 'Calibri' }}>
                  Means, standard deviation, minimum and maximum score, and
                  interpretation for the content standards
               </span>
            </li>
            <li
               className="ListParagraph"
               style={{
                  marginLeft: '10.06pt',
                  paddingLeft: '7.94pt',
                  fontFamily: 'serif',
               }}
            >
               <span style={{ fontFamily: 'Calibri' }}>
                  Percent of students in the proficiency levels per content
                  standards
               </span>
            </li>
            <li
               className="ListParagraph"
               style={{
                  marginLeft: '10.06pt',
                  paddingLeft: '7.94pt',
                  fontFamily: 'serif',
               }}
            >
               <span style={{ fontFamily: 'Calibri' }}>
                  Percent of students who are able to attain each learning
                  competency (provided for the results in all levels)
               </span>
            </li>
         </ul>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '0pt',
               lineHeight: '100%',
               fontSize: '12pt',
            }}
         >
            <strong>&nbsp;</strong>
         </p>
         <p
            style={{
               marginTop: '10pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
            }}
         >
            <strong>
               Guide for the Interpretation for the School Personnel’s Report
            </strong>
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
               textAlign: 'justify',
            }}
         >
            The report for the school personnel is useful in determining the
            learning status of the students in SHS Specialized Subject, the
            specific areas the learners are strong and weak at, and the kind of
            programs and development provided to the learners who are still not
            able to meet the required competencies.
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
               textAlign: 'justify',
            }}
         >
            1.&nbsp; The mean is the center of the distribution of the scores.
            It shows the typical characteristics of the test takers on each
            content standard. Each mean level has a corresponding
            interpretation. The cut-off of the means within the distribution is
            grouped into basic, proficient and competent. Each level of
            proficiency is divided into the upper and lower levels.&nbsp; The
            figure below illustrates the cut-off scores in the curve.
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
               textAlign: 'justify',
            }}
         >
            2.&nbsp; The standard deviation shows how large is the dispersion of
            the distribution. Scores may range from very high to very low and
            this will have a large standard deviation value. Scores with small
            ranges results to small values.
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
               textAlign: 'justify',
            }}
         >
            3.&nbsp; The minimum scores is the lowest score in the distribution
            while the maximum score is the highest score in the distribution.
         </p>
         <p style={{ textAlign: 'center' }}>
            <img
               src="data:image/jpeg;base64,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"
               width={615}
               height={255}
               alt="normal curve -revised.jpg"
            />
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '0pt',
               lineHeight: 'normal',
            }}
         >
            <Row style={{ textAlign: 'center' }}>
               <Col span={8}>Beginner Level</Col>
               <Col span={8}>Basic Level</Col>
               <Col span={8}>Proficient Level</Col>
            </Row>
         </p>
         <p style={{ textAlign: 'center' }}>&nbsp;</p>
         <p style={{ textAlign: 'center' }}>
            Figure 1. Cut-off scores in the Normal Curve
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
            }}
         >
            <strong>&nbsp;</strong>
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
            }}
         >
            The Following tables are the cut-off scores to interpret the level
            of means.
         </p>

         <p
            style={{
               marginTop: '0pt',
               marginBottom: '0pt',
               lineHeight: '115%',
               fontSize: '12pt',
            }}
         >
            Table 1
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
            }}
         >
            Cut-off scores for the proficiency level for the Means for{' '}
            {props.subject}
         </p>
         <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tbody>
               <tr style={{ height: '14.5pt' }}>
                  <td
                     style={{
                        width: '39.3%',
                        borderTop: '1pt solid #000000',
                        borderLeft: '1pt solid #000000',
                        paddingRight: '5.4pt',
                        paddingLeft: '4.9pt',
                        verticalAlign: 'middle',
                        backgroundColor: '#000000',
                     }}
                  >
                     <p style={{ textAlign: 'center', marginBottom: '0pt' }}>
                        <strong>
                           <span style={{ color: '#ffffff' }}>
                              Content Standards
                           </span>
                        </strong>
                     </p>
                  </td>
                  <td
                     colSpan={3}
                     style={{
                        borderTop: '1pt solid #000000',
                        paddingRight: '5.4pt',
                        paddingLeft: '5.4pt',
                        verticalAlign: 'middle',
                        backgroundColor: '#000000',
                     }}
                  >
                     <p style={{ textAlign: 'center', marginBottom: '0pt' }}>
                        <strong>
                           <span style={{ color: '#ffffff' }}>Beginner</span>
                        </strong>
                     </p>
                  </td>
                  <td
                     colSpan={3}
                     style={{
                        borderTop: '1pt solid #000000',
                        paddingRight: '5.4pt',
                        paddingLeft: '5.4pt',
                        verticalAlign: 'middle',
                        backgroundColor: '#000000',
                     }}
                  >
                     <p style={{ textAlign: 'center', marginBottom: '0pt' }}>
                        <strong>
                           <span style={{ color: '#ffffff' }}>Basic</span>
                        </strong>
                     </p>
                  </td>
                  <td
                     colSpan={3}
                     style={{
                        borderTop: '1pt solid #000000',
                        borderRight: '1pt solid #000000',
                        paddingRight: '4.9pt',
                        paddingLeft: '5.4pt',
                        verticalAlign: 'middle',
                        backgroundColor: '#000000',
                     }}
                  >
                     <p style={{ textAlign: 'center', marginBottom: '0pt' }}>
                        <strong>
                           <span style={{ color: '#ffffff' }}>Competent</span>
                        </strong>
                     </p>
                  </td>
               </tr>
               {props.content_standards.map(
                  ({ label, beg1, beg2, bas1, bas2, comp1, comp2 }) =>
                     DiagnosticReportUtils.generateContentStandards(
                        label,
                        beg1,
                        beg2,
                        bas1,
                        bas2,
                        comp1,
                        comp2
                     )
               )}
            </tbody>
         </table>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '0pt',
               lineHeight: '115%',
               fontSize: '12pt',
            }}
         >
            <strong>&nbsp;</strong>
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
               textAlign: 'justify',
            }}
         >
            The frequency of test takers within each proficiency level is
            reported for every content standard. There are tables that
            correspond to each content standard. The count and percent of
            students for basic, proficient and competent levels are provided.
         </p>
         <ul style={{ margin: '0pt', paddingLeft: '0pt' }}>
            <li
               className="ListParagraph"
               style={{
                  marginLeft: '10.06pt',
                  paddingLeft: '7.94pt',
                  fontFamily: 'serif',
               }}
            >
               <span style={{ fontFamily: 'Calibri' }}>
                  Basic level – The student needs to be supported further
                  because several learning competencies were not attained.
               </span>
            </li>
            <li
               className="ListParagraph"
               style={{
                  marginLeft: '10.06pt',
                  paddingLeft: '7.94pt',
                  fontFamily: 'serif',
               }}
            >
               <span style={{ fontFamily: 'Calibri' }}>
                  Proficient level – The student needs some help in some
                  competencies. They need to be motivated to study on their own.
               </span>
            </li>
            <li
               className="ListParagraph"
               style={{
                  marginLeft: '10.06pt',
                  paddingLeft: '7.94pt',
                  fontFamily: 'serif',
               }}
            >
               <span style={{ fontFamily: 'Calibri' }}>
                  Competent – The student is independent to study on their own
                  and is able to meet several learning competencies.
               </span>
            </li>
         </ul>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '0pt',
               lineHeight: '100%',
               fontSize: '12pt',
            }}
         >
            <strong>&nbsp;</strong>
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
               textAlign: 'justify',
            }}
         >
            When low mean scores are obtained (lower basic level) with large
            percent of students in the basic level, check the results showing
            the specific competencies. The set of competencies within a content
            standard may contain high and low attainment. It is recommended to
            address the low percent of attainment. The low percent of attainment
            are those learning competencies with percentage below 50%.
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '0pt',
               lineHeight: '100%',
               fontSize: '12pt',
            }}
         >
            <strong>&nbsp;</strong>
         </p>
         <table
            style={{
               width: '100%',
               border: '0.75pt solid #000000',
               borderCollapse: 'collapse',
            }}
         >
            <tbody>
               <tr>
                  <td
                     style={{
                        width: '58.4pt',
                        borderRight: '0.75pt solid #000000',
                        borderBottom: '0.75pt solid #000000',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           lineHeight: '115%',
                           fontSize: '12pt',
                        }}
                     >
                        0% - 40%
                     </p>
                  </td>
                  <td
                     style={{
                        width: '446.4pt',
                        borderLeft: '0.75pt solid #000000',
                        borderBottom: '0.75pt solid #000000',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           lineHeight: '115%',
                           fontSize: '12pt',
                        }}
                     >
                        Very few students are able to meet the learning
                        competency. The students need to review the lessons
                        again.
                     </p>
                  </td>
               </tr>
               <tr>
                  <td
                     style={{
                        width: '58.4pt',
                        borderTop: '0.75pt solid #000000',
                        borderRight: '0.75pt solid #000000',
                        borderBottom: '0.75pt solid #000000',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           lineHeight: '115%',
                           fontSize: '12pt',
                        }}
                     >
                        41%- 60%
                     </p>
                  </td>
                  <td
                     style={{
                        width: '446.4pt',
                        borderTop: '0.75pt solid #000000',
                        borderLeft: '0.75pt solid #000000',
                        borderBottom: '0.75pt solid #000000',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           lineHeight: '115%',
                           fontSize: '12pt',
                        }}
                     >
                        About half of the class are able to meet the learning
                        competency. The students need to review the lessons
                        again.
                     </p>
                  </td>
               </tr>
               <tr>
                  <td
                     style={{
                        width: '58.4pt',
                        borderTop: '0.75pt solid #000000',
                        borderRight: '0.75pt solid #000000',
                        borderBottom: '0.75pt solid #000000',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           lineHeight: '115%',
                           fontSize: '12pt',
                        }}
                     >
                        61% - 80%
                     </p>
                  </td>
                  <td
                     style={{
                        width: '446.4pt',
                        borderTop: '0.75pt solid #000000',
                        borderLeft: '0.75pt solid #000000',
                        borderBottom: '0.75pt solid #000000',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           lineHeight: '115%',
                           fontSize: '12pt',
                        }}
                     >
                        Majority of the students are able to meet the learning
                        competency. The remaining students can work on
                        supplementary learning resources to study.
                     </p>
                  </td>
               </tr>
               <tr>
                  <td
                     style={{
                        width: '58.4pt',
                        borderTop: '0.75pt solid #000000',
                        borderRight: '0.75pt solid #000000',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           lineHeight: '115%',
                           fontSize: '12pt',
                        }}
                     >
                        81% - 100%
                     </p>
                  </td>
                  <td
                     style={{
                        width: '446.4pt',
                        borderTop: '0.75pt solid #000000',
                        borderLeft: '0.75pt solid #000000',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           lineHeight: '115%',
                           fontSize: '12pt',
                        }}
                     >
                        A large number of students are able to meet the learning
                        competency. The remaining students can be provided with
                        extra support.
                     </p>
                  </td>
               </tr>
            </tbody>
         </table>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '0pt',
               lineHeight: '100%',
               fontSize: '12pt',
            }}
         >
            <strong>&nbsp;</strong>
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
            }}
         >
            Recommendations on below 40% attainment of competencies:
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '0pt',
               lineHeight: '100%',
               fontSize: '12pt',
            }}
         >
            <strong>&nbsp;</strong>
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
            }}
         >
            1.&nbsp; Check if the competency is covered in class
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
            }}
         >
            2.&nbsp; Check if the competency is covered as part of the lesson in
            the syllabus
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
            }}
         >
            3.&nbsp; Check the duration of time devoted in teaching the
            competency
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
            }}
         >
            4.&nbsp; Review how was the competency taught
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
            }}
         >
            5.&nbsp; Review if enough opportunities and student activities were
            provided
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '0pt',
               lineHeight: '100%',
               fontSize: '12pt',
            }}
         >
            <strong>&nbsp;</strong>
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
            }}
         >
            <strong>
               Guide for the Interpretation for the Student’s Report
            </strong>
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '0pt',
               lineHeight: '100%',
               fontSize: '12pt',
            }}
         >
            <strong>&nbsp;</strong>
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
            }}
         >
            The SHS Specialized Subject learning assessment package provides you
            with two kinds of results: (1) The score per competency and (2)
            score for the content standards.
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '0pt',
               lineHeight: '100%',
               fontSize: '12pt',
            }}
         >
            <strong>&nbsp;</strong>
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
               textAlign: 'justify',
            }}
         >
            <strong>Competency Score.</strong>&nbsp; The score for the
            competency is found in the succeeding page. Each item in the test is
            aligned to a particular learning competency. If the mark is “1”,{' '}
            <em>the student is able to meet the competency</em>. If the mark is
            “0”, <em>the student is not able to meet that competency</em>. The
            percentage beside the competency score is the percent of the entire
            level who is able to meet the learning competency.
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '0pt',
               lineHeight: '100%',
               fontSize: '12pt',
            }}
         >
            <strong>&nbsp;</strong>
         </p>
         <table
            style={{
               width: '100%',
               border: '0.75pt solid #000000',
               borderCollapse: 'collapse',
            }}
         >
            <tbody>
               <tr>
                  <td
                     style={{
                        width: '58.4pt',
                        borderRight: '0.75pt solid #000000',
                        borderBottom: '0.75pt solid #000000',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           lineHeight: '115%',
                           fontSize: '12pt',
                        }}
                     >
                        0% - 40%
                     </p>
                  </td>
                  <td
                     style={{
                        width: '446.4pt',
                        borderLeft: '0.75pt solid #000000',
                        borderBottom: '0.75pt solid #000000',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           lineHeight: '115%',
                           fontSize: '12pt',
                        }}
                     >
                        Very few students are able to meet the learning
                        competency. The students need to review the lessons
                        again.
                     </p>
                  </td>
               </tr>
               <tr>
                  <td
                     style={{
                        width: '58.4pt',
                        borderTop: '0.75pt solid #000000',
                        borderRight: '0.75pt solid #000000',
                        borderBottom: '0.75pt solid #000000',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           lineHeight: '115%',
                           fontSize: '12pt',
                        }}
                     >
                        41%- 60%
                     </p>
                  </td>
                  <td
                     style={{
                        width: '446.4pt',
                        borderTop: '0.75pt solid #000000',
                        borderLeft: '0.75pt solid #000000',
                        borderBottom: '0.75pt solid #000000',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           lineHeight: '115%',
                           fontSize: '12pt',
                        }}
                     >
                        About half of the class are able to meet the learning
                        competency. The students need to review the lessons
                        again.
                     </p>
                  </td>
               </tr>
               <tr>
                  <td
                     style={{
                        width: '58.4pt',
                        borderTop: '0.75pt solid #000000',
                        borderRight: '0.75pt solid #000000',
                        borderBottom: '0.75pt solid #000000',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           lineHeight: '115%',
                           fontSize: '12pt',
                        }}
                     >
                        61% - 80%
                     </p>
                  </td>
                  <td
                     style={{
                        width: '446.4pt',
                        borderTop: '0.75pt solid #000000',
                        borderLeft: '0.75pt solid #000000',
                        borderBottom: '0.75pt solid #000000',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           lineHeight: '115%',
                           fontSize: '12pt',
                        }}
                     >
                        Majority of the students are able to meet the learning
                        competency. The remaining students can work on
                        supplementary learning resources to study.
                     </p>
                  </td>
               </tr>
               <tr>
                  <td
                     style={{
                        width: '58.4pt',
                        borderTop: '0.75pt solid #000000',
                        borderRight: '0.75pt solid #000000',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           lineHeight: '115%',
                           fontSize: '12pt',
                        }}
                     >
                        81% - 100%
                     </p>
                  </td>
                  <td
                     style={{
                        width: '446.4pt',
                        borderTop: '0.75pt solid #000000',
                        borderLeft: '0.75pt solid #000000',
                        paddingRight: '5.03pt',
                        paddingLeft: '5.03pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <p
                        style={{
                           marginTop: '0pt',
                           marginBottom: '0pt',
                           lineHeight: '115%',
                           fontSize: '12pt',
                        }}
                     >
                        A large number of students are able to meet the learning
                        competency. The remaining students can be provided with
                        extra support.
                     </p>
                  </td>
               </tr>
            </tbody>
         </table>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
            }}
         >
            <strong>&nbsp;</strong>
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '10pt',
               lineHeight: '115%',
               fontSize: '12pt',
            }}
         >
            <strong>Content Standard Score.</strong>The result for the content
            standards is expressed in terms of the raw score, percent correct,
            standard score, and proficiency level.
         </p>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '0pt',
               lineHeight: '100%',
               fontSize: '12pt',
            }}
         >
            <strong>&nbsp;</strong>
         </p>
         <ul style={{ margin: '0pt', paddingLeft: '0pt' }}>
            <li
               className="ListParagraph"
               style={{
                  marginLeft: '10.06pt',
                  paddingLeft: '7.94pt',
                  fontFamily: 'serif',
                  textAlign: 'justify',
               }}
            >
               <strong>
                  <span style={{ fontFamily: 'Calibri' }}>Raw Score.</span>
               </strong>
               <span style={{ fontFamily: 'Calibri' }}>
                  The raw score is the total number of correct answers for the
                  content standard.&nbsp;
               </span>
            </li>
            <li
               className="ListParagraph"
               style={{
                  marginLeft: '10.06pt',
                  paddingLeft: '7.94pt',
                  fontFamily: 'serif',
                  textAlign: 'justify',
               }}
            >
               <strong>
                  <span style={{ fontFamily: 'Calibri' }}>
                     Percent Correct.
                  </span>
               </strong>
               <span style={{ fontFamily: 'Calibri' }}>&nbsp;&nbsp;</span>
               <span style={{ fontFamily: 'Calibri' }}>
                  The percent correct is the raw score converted into
                  percentage. The percent correct provides with an easier way to
                  determine how many correct answers you are able to obtain for
                  each content standard. If the percent correct is close to
                  100%, the more correct answers the student is able to attain.
               </span>
            </li>
            <li
               className="ListParagraph"
               style={{
                  marginLeft: '10.06pt',
                  paddingLeft: '7.94pt',
                  fontFamily: 'serif',
                  textAlign: 'justify',
               }}
            >
               <strong>
                  <span style={{ fontFamily: 'Calibri' }}>Standard score.</span>
               </strong>
               <span style={{ fontFamily: 'Calibri' }}>
                  &nbsp;The scores are converted into a standard score to allow
                  comparison of scores across content standards and across
                  levels. A standard score near 0.0 means that the students’
                  standing in the content standard is within the majority of the
                  test takers. A standard score of more than 1.00 mean that the
                  attainment of the competencies is high because there are
                  several correct answers. The following are the guide for
                  interpreting the standard scores:
               </span>
            </li>
         </ul>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '0pt',
               lineHeight: '100%',
               fontSize: '12pt',
            }}
         >
            <strong>&nbsp;</strong>
         </p>
         <table
            style={{
               width: '100%',
               border: '0.75pt solid #000000',
               borderCollapse: 'collapse',
            }}
         >
            <tbody>
               <tr>
                  <td
                     style={{
                        width: '103.5pt',
                        borderTop: '1pt solid #000000',
                        borderLeft: '1pt solid #000000',
                        paddingRight: '5.4pt',
                        paddingLeft: '4.9pt',
                        verticalAlign: 'middle',
                        backgroundColor: '#000000',
                     }}
                  >
                     <strong>
                        <span style={{ color: '#ffffff' }}>
                           Proficiency Level
                        </span>
                     </strong>
                  </td>
                  <td
                     style={{
                        width: '119.2pt',
                        borderTop: '1pt solid #000000',
                        paddingRight: '5.4pt',
                        paddingLeft: '5.4pt',
                        verticalAlign: 'middle',
                        backgroundColor: '#000000',
                     }}
                  >
                     <strong>
                        <span style={{ color: '#ffffff' }}>
                           Range of Standard Score
                        </span>
                     </strong>
                  </td>
                  <td
                     style={{
                        width: '271.3pt',
                        borderTop: '1pt solid #000000',
                        borderRight: '1pt solid #000000',
                        paddingRight: '4.9pt',
                        paddingLeft: '5.4pt',
                        verticalAlign: 'middle',
                        backgroundColor: '#000000',
                     }}
                  >
                     <strong>
                        <span style={{ color: '#ffffff' }}>Interpretation</span>
                     </strong>
                  </td>
               </tr>
               <tr>
                  <td
                     style={{
                        width: '103.5pt',
                        borderTop: '1pt solid #000000',
                        borderLeft: '1pt solid #000000',
                        borderBottom: '1pt solid #000000',
                        paddingRight: '5.4pt',
                        paddingLeft: '4.9pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <strong>Beginner</strong>
                  </td>
                  <td
                     style={{
                        width: '119.2pt',
                        borderTop: '1pt solid #000000',
                        borderBottom: '1pt solid #000000',
                        paddingRight: '5.4pt',
                        paddingLeft: '5.4pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     Less than -0.5
                  </td>
                  <td
                     style={{
                        width: '271.3pt',
                        borderTop: '1pt solid #000000',
                        borderRight: '1pt solid #000000',
                        borderBottom: '1pt solid #000000',
                        paddingRight: '4.9pt',
                        paddingLeft: '5.4pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     There are several competencies that the student did not
                     master and may need thorough instructional support.
                  </td>
               </tr>
               <tr>
                  <td
                     style={{
                        width: '103.5pt',
                        borderLeft: '1pt solid #000000',
                        paddingRight: '5.4pt',
                        paddingLeft: '4.9pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <strong>Basic Level</strong>
                  </td>
                  <td
                     style={{
                        width: '119.2pt',
                        paddingRight: '5.4pt',
                        paddingLeft: '5.4pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     -0.51 to 1.0
                  </td>
                  <td
                     style={{
                        width: '271.3pt',
                        borderRight: '1pt solid #000000',
                        paddingRight: '4.9pt',
                        paddingLeft: '5.4pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     The student has learned sufficient competencies to move to
                     the succeeding level of learning. Needs instructional
                     support to move to the next level.
                  </td>
               </tr>
               <tr>
                  <td
                     style={{
                        width: '103.5pt',
                        borderTop: '1pt solid #000000',
                        borderLeft: '1pt solid #000000',
                        borderBottom: '1pt solid #000000',
                        paddingRight: '5.4pt',
                        paddingLeft: '4.9pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     <strong>Competent Level</strong>
                  </td>
                  <td
                     style={{
                        width: '119.2pt',
                        borderTop: '1pt solid #000000',
                        borderBottom: '1pt solid #000000',
                        paddingRight: '5.4pt',
                        paddingLeft: '5.4pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     1.00 and above
                  </td>
                  <td
                     style={{
                        width: '271.3pt',
                        borderTop: '1pt solid #000000',
                        borderRight: '1pt solid #000000',
                        borderBottom: '1pt solid #000000',
                        paddingRight: '4.9pt',
                        paddingLeft: '5.4pt',
                        verticalAlign: 'middle',
                     }}
                  >
                     The student has mastered the required competencies and
                     needs little instruction to learn succeeding lessons.
                  </td>
               </tr>
            </tbody>
         </table>
         <p
            style={{
               marginTop: '0pt',
               marginBottom: '0pt',
               lineHeight: '115%',
               fontSize: '12pt',
            }}
         >
            <strong>&nbsp;</strong>
         </p>
         <ul style={{ margin: '0pt', paddingLeft: '0pt' }}>
            <li
               className="ListParagraph"
               style={{
                  marginLeft: '10.06pt',
                  paddingLeft: '7.94pt',
                  fontFamily: 'serif',
               }}
            >
               <strong>
                  <span style={{ fontFamily: 'Calibri' }}>
                     Proficiency Level.
                  </span>
               </strong>
               <span style={{ fontFamily: 'Calibri' }}>
                  &nbsp;The proficiency level describes your present level of
                  attainment on content standard. The levels of proficiency
                  start from beginner to basic to competent. The beginner level
                  means few correct answers attained in the content standard.
                  The basic level means that the score is within the majority of
                  the test takers. Competent means that several correct answers
                  are attained.&nbsp;
               </span>
            </li>
         </ul>
      </div>
   );
}
